import { Draft, timingFromDays } from "./inboxDraft.types";

/**
 * Removes the draft at `index`. When the deletion leaves a single draft, that
 * draft becomes the lead message again and is reset to "now" (a lone reply is
 * always sent immediately) — otherwise a leftover follow-up date would linger
 * in the editor. Drafts other than a final sole survivor keep their timing
 * untouched.
 */
export const removeDraftAt = (drafts: Draft[], index: number): Draft[] => {
	const next = drafts.filter((_, i) => i !== index);

	if (next.length === 1) {
		next[0] = { ...next[0], timing: timingFromDays(0) };
	}

	return next;
};
